import type { AnchorHTMLAttributes, ReactNode } from 'react';

interface SafeLinkWithFallbackProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href?: string | null;
  children: string | ReactNode;
}

export const SafeLinkWithFallback = ({ children, href, ...props }: SafeLinkWithFallbackProps) => {
  if (!href) return <>{children}</>;
  return (
    <a href={href} {...props}>
      {children}
    </a>
  );
};
